import { Paper as _Paper, styled } from '@mui/material'

export const Paper = styled(_Paper)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.grey[50],
}))
